import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface AdminAccountsRequest {
    searchtxt: string;
    page: number;
    limit: string;
}

export type AdminAccountListItem = {
    idx: number;
    a_id: string;
    a_name: string;
    a_auth: string | null;
    a_sdate: string | null;
    a_edate: string | null;
    s_level: string | null;
};

export interface AdminAccountsResponseData {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: AdminAccountListItem[];
}

export const useGetConsoleAdminAccounts = ({
    searchtxt,
    page,
    limit,
}: AdminAccountsRequest): UseQueryResult<AdminAccountsResponseData, Error> => {
    return useQuery({
        queryKey: ["useGetConsoleAdminAccounts", searchtxt, page, limit],
        queryFn: async () => {
            const response = await axiosInstance.get(enum_api_uri.get_console_admin_accounts, {
                params: { searchtxt, page, limit },
            });
            return response.data.data;
        },
    });
};
